// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__11N-d","footer":"ReportModalFilter_footer__2jzOV"};